import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import Forms from "../../../../Componets/Form";
import toast from "react-hot-toast";
import Header from "../../../../Componets/Header";
import {
  create_invoice,
  get_invoice,
  update_invoice,
} from "../../../../Controllers/Sales/Invoices";
import {
  get_quote,
} from "../../../../Controllers/Sales/Quotes";
import { get_booking } from "../../../../Controllers/Sales/Bookings";
import forms from "../../../../Data/Forms/Sales/Invoices/forms";
import headers from "../../../../Data/Forms/Sales/Invoices/headers";
import Loadercomponent from "../../../../Componets/Loader";
import Bodycomponent from "../../../../Componets/Formcomponents/body";
import Titlecomponent from "../../../../Componets/Formcomponents/title";
import Formdata from "../../../../Componets/Formcomponents/formdata";
import Headercomponent from "../../../../Componets/Formcomponents/header";
import Invoicetable from "../../../../Data/Forms/Sales/Invoices/table";
import dayjs from "dayjs";

const InvoicesForm = () => {
  let { id } = useParams();
  let navigate = useNavigate();

  console.log("id", id)

  const [loader, setLoader] = useState(false);
  const [buttonLoader, setButtonLoader] = useState(false);
  const [header, setHeader] = useState(headers);

  const location = useLocation();
  const pathParts = location.pathname.split("/");
  const moduleName = pathParts[2];

  const queryParams = new URLSearchParams(location.search);
  const booking_id = queryParams.get("booking");
  const quotes_id = queryParams.get("quotes");

  const isQuotation = moduleName === "sales" ? true : false;

  const getFilteredFormOptions = () => {
    const baseForm = forms[0];

    if (id) {
      return [baseForm];
    } else {
      const filteredOptions = baseForm.options.filter(
        (option) => option.name !== "Status"
      );

      return [
        {
          ...baseForm,
          options: filteredOptions,
        },
      ];
    }
  };

  const [values, setValues] = useState(getFilteredFormOptions());
  const [note, setNote] = useState();

  const focus = useRef([]);

  const [details, setDetails] = useState([
    {
      id: "",
      description: null,
      name: "",
      unit: "",
      unit_name: "",
      unit_details_options: null,
      conversion: 0,
      quantity: "",
      invoice: "",
      invoice_price: "",
      invoice_options: null,
      delivered: "",
      tax: 0,
      free: "",
      barcode: "",
      price_per_unit: "",
      discounted_price: "",
      discounted_percentage: "",
      sale_price: "",
      expiry_date: "",
      tax_amount: "0.000",
      total: 0,
      source: "Sales"
    },
  ]);

  const [totals, setTotals] = useState({
    subtotal: "0.000",
    taxamount: "0.000",
    discount: 0,
    discount_value: 0,
    discount_type: 0,
    delivery: 0,
    delivery_status: 2,
    delivery_date: dayjs(),
    payment_status: 2,
    payment_types: ["Cash"],
    /*  payments: {
       Cash: "",
       "Debit card": "",
       "Credit card": "",
       "Bank transfer": "",
       "Online payment": "",
       Cheque: "",
     }, */
    payments: [{
      id: `temp-cash-initial`,
      name: "Cash",
      amount: ""
    }],
    paid: 0,
    remaining: 0,
    total: "0.000",
  });

  const findFieldIndex = (fieldName) => {
    return values[0].options.findIndex((option) => option.name === fieldName);
  };

  const detailsvalidation = (tabledata) => {
    let params = {};

    if (details?.length > 0) {
      let total = details?.length;
      let count = 0;

      let validated = [];
      details?.map((v, i) => {
        if (count == i) {
          if (!v?.description) {
            document.getElementById(
              `description${i}`
            ).textContent = `Description is required`;
            focus.current[`description${i}`].current.focus();
          } else if (!v?.sale_price) {
            document.getElementById(
              `sale_price${i}`
            ).textContent = `Sale price is required`;
            focus.current[`sale_price${i}`].current.focus();
          } else if (!v?.quantity) {
            document.getElementById(
              `quantity${i}`
            ).textContent = `Quantity is required`;
            focus.current[`quantity${i}`].current.focus();
          } else {
            document.getElementById(`description${i}`).textContent = ``;
            document.getElementById(`sale_price${i}`).textContent = ``;
            document.getElementById(`quantity${i}`).textContent = ``;

            validated?.push(v);
            count++;
          }
        }
      });

      if (count == total) {
        params = {
          status: true,
          data: {
            ...tabledata,
            details: validated,
          },
        };

        return params;
      } else {
        params = {
          status: false,
          data: null,
        };

        return params;
      }

    } else {
      toast?.error("Details not found");
    }
  };

  const totalsvalidation = (tabledata) => {
    let params = {};

    let count_totals = 0;

    if (totals?.delivery_status == 2 && !totals?.delivery_date) {
      document.getElementById(
        `delivery_date`
      ).textContent = `Delivery Date is required`;
      focus.current[`delivery_date`].current.focus();
    } else if (totals?.payment_status && !totals?.payment_types?.length) {
      document.getElementById(
        `payment_types`
      ).textContent = `Payment type is required`;
      focus.current[`payment_types`].current.focus();
    } else {
      if (totals?.delivery_status == 2) {
        document.getElementById(`delivery_date`).textContent = ``;
      }
      if (totals?.payment_status) {
        document.getElementById(`payment_types`).textContent = ``;
      }
      count_totals++;
    }

    if (count_totals) {
      let total_payment_types = totals?.payment_types?.length;
      let count_payment_types = 0;

      let total_amount = 0;


      if (totals?.payment_types?.length > 0) {
        /* totals?.payment_types?.map((v, i) => {
          if (count_payment_types == i) {
            if (!totals?.payments?.[v]?.amount) {
              document.getElementById(`${v}`).textContent = `${v} is required`;
              focus.current[`${v}`].current.focus();
            } else {
              total_amount =
                parseFloat(total_amount || 0) +
                parseFloat(totals?.payments?.[v]?.amount || 0);
              document.getElementById(`${v}`).textContent = ``;
              count_payment_types++;
            }
          }
        }); */

        totals?.payment_types?.forEach((type, i) => {
          const paymentsOfType = totals?.payments?.filter(p => p.name === type);
          const hasValidPayment = paymentsOfType?.some(p => p.amount && parseFloat(p.amount) > 0);

          if (!hasValidPayment) {
            document.getElementById(`payment_type_${type}`).textContent = `${type} payment is required`;
            focus.current[`payment_type_${type}`]?.current?.focus();
          } else {
            const typeTotal = paymentsOfType.reduce(
              (sum, p) => sum + parseFloat(p.amount || 0),
              0
            );

            total_amount += typeTotal;
            document.getElementById(`payment_type_${type}`).textContent = ``;
            count_payment_types++;
          }
        });

        if (total_amount == 0 && !tabledata?.customer) {
          toast?.error("Customer required for credit");
        } else {
          if (count_payment_types == total_payment_types) {
            params = {
              status: true,
              data: {
                ...tabledata,
                id: id ? id : "",
                subtotal: totals?.subtotal,
                taxamount: totals?.taxamount,
                discount_value: totals?.discount_value,
                discount_type: totals?.discount_type,
                discount: totals?.discount,
                delivery: totals?.delivery,
                delivery_status: totals?.delivery_status,
                delivery_date: totals?.delivery_date,
                payment_status: totals?.payment_status,
                payment_types: totals?.payment_types,
                payments: totals?.payments,
                total: totals?.total,
                note: note,
                source: "Sales"
              },
            };
            return params;
          } else {
            params = {
              status: false,
              data: null,
            };

            return params;
          }
        }
      } else {
        params = {
          status: true,
          data: {
            ...tabledata,
            id: id ? id : "",
            subtotal: totals?.subtotal,
            taxamount: totals?.taxamount,
            discount_value: totals?.discount_value,
            discount_type: totals?.discount_type,
            discount: totals?.discount,
            delivery: totals?.delivery,
            delivery_status: totals?.delivery_status,
            delivery_date: totals?.delivery_date,
            payment_status: totals?.payment_status,
            payment_types: totals?.payment_types,
            payments: totals?.payments,
            total: totals?.total,
            note: note,
            source: "Sales"
          },
        };

        return params;
      }
    }
  };

  const formdata = async (data) => {
    if (data?.status) {
      if (buttonLoader) return;

      const tabledetailsvalidation = detailsvalidation(data?.data);

      if (tabledetailsvalidation?.status) {
        const tabletotalvalidation = totalsvalidation(
          tabledetailsvalidation?.data
        );

        if (tabletotalvalidation?.status) {
          setButtonLoader(true);

          const normalizedPayments = tabletotalvalidation.data.payments
            .filter(p => p.amount && parseFloat(p.amount) > 0)
            .map(p => ({
              ...p,
              amount: parseFloat(p.amount)
            }));

          const payload = {
            ...tabletotalvalidation.data,
            payments: normalizedPayments,
            booking_id: booking_id || null,
          };

          const invoice = id
            ? await update_invoice(payload)
            : await create_invoice(payload);

          if (invoice?.status) {
            navigate(-1);
            toast.success(invoice?.message);
          } else {
            toast.error(invoice?.message);
          }
        }
      }
    }
  };

  const handleQuotationNumberChange = async (number) => {
    if (!number) return;

    const res = await get_quote({ id: number }); // or { number } depending on your API
    if (!res?.status) {
      toast.error(res?.message || "Quotation not found");
      return;
    }

    const quote = res.data;
    const currentValues = [...values];

    // --- Populate header fields ---
    const customerIndex = findFieldIndex("Customer");
    const salesmanIndex = findFieldIndex("Salesman");
    const dueDateIndex = findFieldIndex("Due Date");
    const lpoNumberIndex = findFieldIndex("LPO Number");
    const lpoDateIndex = findFieldIndex("LPO Date");

    if (customerIndex !== -1 && quote.customer?._id) {
      currentValues[0].options[customerIndex].form.value = quote.customer._id;
      currentValues[0].options[customerIndex].form.options = [
        {
          value: quote.customer._id,
          label: quote.customer.name && quote.customer.phone
            ? `${quote.customer.name} (${quote.customer.phone})`
            : quote.customer.name || quote.customer.phone || "",
        },
      ];
    }

    if (salesmanIndex !== -1 && quote.salesman?._id) {
      currentValues[0].options[salesmanIndex].form.value = quote.salesman._id;
      currentValues[0].options[salesmanIndex].form.options = [
        { value: quote.salesman._id, label: quote.salesman.name },
      ];
    }

    if (dueDateIndex !== -1 && quote.due_date) {
      currentValues[0].options[dueDateIndex].form.value = quote.due_date;
    }
    if (lpoNumberIndex !== -1 && quote.lpo_number) {
      currentValues[0].options[lpoNumberIndex].form.value = quote.lpo_number;
    }
    if (lpoDateIndex !== -1 && quote.lpo_date) {
      currentValues[0].options[lpoDateIndex].form.value = quote.lpo_date;
    }

    // --- Populate line items (same shape as handleData) ---
    const data = quote.details?.map((value) => {
      let stock = value?.description?.stock;
      if (value?.unit !== value?.description?._id) {
        value?.inventory_unit_details?.forEach((v) => {
          if (value?.unit === v?._id) stock = v?.stock;
        });
      }

      return {
        id: quotes_id,                   // new line — no existing _id
        type: value?.typeModel === "services" ? "service"
          : value?.typeModel === "inventory" ? "inventory" : null,
        description: value?.description?._id,
        batch: value?.description?.number,
        expiry_date: value?.description?.expiry_date,
        category: value?.description?.product?.category ?? null,
        stock,
        name: value?.name,
        unit: value?.unit,
        unit_name: value?.unit_name,
        unit_details_options: value?.unit_details_options,
        conversion: value?.conversion,
        invoice_price: value?.invoice_price,
        quantity: value?.quantity,
        delivered: value?.delivered,
        free: value?.free,
        tax_details: value?.tax ?? null,
        tax: value?.tax?.name ?? null,
        barcode: value?.barcode,
        price_per_unit: value?.price_per_unit,
        sale_price: value?.sale_price,
        discount_price: value?.discount_price,
        discount_percentage: value?.discount_percentage,
        retail_price: value?.description?.product?.sale_price ?? value?.sale_price ?? 0,
        tax_amount: value?.tax_amount,
        total: value?.total,
        source: "Sales",
      };
    }) ?? [];

    // --- Populate totals ---
    setTotals((prev) => ({
      ...prev,
      subtotal: quote.subtotal ?? prev.subtotal,
      taxamount: quote.taxamount ?? prev.taxamount,
      discount: quote.discount ?? prev.discount,
      discount_value: quote.discount_value ?? prev.discount_value,
      discount_type: quote.discount_type ?? prev.discount_type,
      delivery: quote.delivery ?? prev.delivery,
      total: quote.total ?? prev.total,
    }));

    setValues(currentValues);
    setDetails(data);
    toast.success("Quotation loaded successfully");
  };

  const selectHandlers = {
    quotation_number: handleQuotationNumberChange, // key must match the field `name` in forms[]
  };

  const handleBookingLoad = async (bookingId) => {
    if (!bookingId) return;

    const result = await get_booking({ id: bookingId });
    if (!result?.status) {
      toast.error(result?.message || "Booking not found");
      return;
    }

    const booking = result.data;

    // --- Populate header fields ---
    const customerIndex = findFieldIndex("Customer");
    const salesmanIndex = findFieldIndex("Salesman");
    const dueDateIndex = findFieldIndex("Due Date");

    const currentValues = [...values];

    if (customerIndex !== -1 && booking.customer?._id) {
      currentValues[0].options[customerIndex].form.value = booking.customer._id;
      currentValues[0].options[customerIndex].form.options = [{
        value: booking.customer._id,
        label: booking.customer.name || booking.customer.phone || ""
      }];
    }

    if (salesmanIndex !== -1 && booking.salesman?._id) {
      currentValues[0].options[salesmanIndex].form.value = booking.salesman._id;
      currentValues[0].options[salesmanIndex].form.options = [{
        value: booking.salesman._id,
        label: booking.salesman.name
      }];
    }

    if (dueDateIndex !== -1 && booking.due_date) {
      currentValues[0].options[dueDateIndex].form.value = booking.due_date;
    }

    // --- Populate line items from booking details ---
    const items = booking.details?.map(item => ({
      id: "",
      description: item.description?._id,
      name: item.name,
      unit: item.unit,
      unit_name: item.unit_name,
      quantity: item.quantity,
      delivered: item.quantity,
      sale_price: item.sale_price,
      discount_percentage: item.discount_percentage || 0,
      discount_price: item.discount_price || 0,
      tax: item.tax,
      tax_amount: item.tax_amount,
      total: item.total,
      stock: item.description?.stock,
      batch: item.description?.number,
      // add any other fields your invoice table expects
    })) || [];



    const totalDeposit = (booking.deposit || []).reduce(
      (sum, d) => sum + (parseFloat(d.amount) || 0),
      0
    );

    const depositPayments = (booking.deposit || []).map(d => ({
      id: `booking-deposit-${bookingId}-${d._id || Math.random()}`,
      name: d.type || "Deposit",
      amount: parseFloat(d.amount) || 0,
    }));
    // --- Set totals and pre-fill deposit as payment ---
    const paymentTypes = [
      ...new Set(
        depositPayments.map(p => p.name)
      )
    ];

    setTotals({
      subtotal: booking.subtotal || 0,
      taxamount: booking.taxamount || 0,
      discount: 0,
      discount_value: 0,
      discount_type: 0,
      delivery: 0,
      delivery_status: 2,
      delivery_date: dayjs(),
      payment_status: 2,

      // important
      payment_types: paymentTypes.length
        ? paymentTypes
        : ["Cash"],

      payments: depositPayments.length
        ? depositPayments
        : [{
          id: `temp-cash-initial`,
          name: "Cash",
          amount: ""
        }],

      paid: totalDeposit,
      remaining: (booking.total || 0) - totalDeposit,
      total: booking.total || 0,
    });
    setValues(currentValues);
    setDetails(items);
    setNote(booking.note || "");

    toast.success("Booking loaded");
  };

  const handleData = (invoice) => {
    let customer = invoice?.customer?._id ? invoice?.customer?._id : null;
    let number = (isQuotation && !id) ? "" : invoice?.number ? invoice?.number : "";
    let date = invoice?.date ? invoice?.date : "";
    let due_date = invoice?.due_date ? invoice?.due_date : "";
    let lpo_number = invoice?.lpo_number ? invoice?.lpo_number : "";
    let lpo_date = invoice?.lpo_date ? invoice?.lpo_date : "";
    let salesman = invoice?.salesman?._id ? invoice?.salesman?._id : null;
    let status = invoice?.status ? invoice?.status : 0;

    let salesman_options = invoice?.salesman?._id
      ? [
        {
          value: invoice?.salesman?._id,
          label: invoice?.salesman?.name,
        },
      ]
      : null;

    let customer_option = invoice?.customer?._id
      ? [
        {
          value: invoice?.customer?._id,
          label:
            invoice?.customer?.name && invoice?.customer?.phone
              ? invoice?.customer?.name +
              " (" +
              invoice?.customer?.phone +
              ")"
              : invoice?.customer?.name
                ? invoice?.customer?.name
                : invoice?.customer?.phone
                  ? invoice?.customer?.phone
                  : "",
        },
      ]
      : null;

    const currentValues = [...values];

    const customerIndex = findFieldIndex("Customer");
    const numberIndex = findFieldIndex("Number");
    const dateIndex = findFieldIndex("Date");
    const dueDateIndex = findFieldIndex("Due Date");
    const lpoNumberIndex = findFieldIndex("LPO Number");
    const lpoDateIndex = findFieldIndex("LPO Date");
    const salesmanIndex = findFieldIndex("Salesman");
    const statusIndex = findFieldIndex("Status");

    if (customerIndex !== -1) {
      currentValues[0].options[customerIndex].form.value = customer;
      currentValues[0].options[customerIndex].form.options = customer_option;
    }

    if (numberIndex !== -1) {
      currentValues[0].options[numberIndex].form.value = number;
    }

    if (dateIndex !== -1) {
      currentValues[0].options[dateIndex].form.value = date;
    }

    if (dueDateIndex !== -1) {
      currentValues[0].options[dueDateIndex].form.value = due_date;
    }

    if (lpoNumberIndex !== -1) {
      currentValues[0].options[lpoNumberIndex].form.value = lpo_number;
    }

    if (lpoDateIndex !== -1) {
      currentValues[0].options[lpoDateIndex].form.value = lpo_date;
    }

    if (salesmanIndex !== -1) {
      currentValues[0].options[salesmanIndex].form.value = salesman;
      currentValues[0].options[salesmanIndex].form.options = salesman_options;
    }

    if (statusIndex !== -1) {
      currentValues[0].options[statusIndex].form.value = status;
    }

    let data = [];

    invoice?.details?.map((value, index) => {
      let stock = value?.description?.stock;

      if (value?.unit != value?.description?._id) {
        value?.inventory_unit_details?.map((v, i) => {
          if (value?.unit == v?._id) {
            stock = v?.stock;
          }
        });
      }

      data?.push({
        id: value?._id,
        type: value?.typeModel === "services" ? "service" : value?.typeModel === "inventory" ? "inventory" : null,
        description: value?.description?._id,
        batch: value?.description?.number,
        expiry_date: value?.description?.expiry_date,
        category: value?.description?.product?.category ? value?.description?.product?.category : null,
        stock: stock,
        name: value?.name,
        unit: value?.unit,
        unit_name: value?.unit_name,
        unit_details_options: value?.unit_details_options,
        conversion: value?.conversion,
        invoice_price: value?.invoice_price,
        quantity: value?.quantity,
        delivered: value?.delivered,
        free: value?.free,
        tax_details: value.tax ? value.tax : null,
        tax: value?.tax?.name ? value?.tax?.name : null,
        barcode: value?.barcode,
        price_per_unit: value?.price_per_unit,
        sale_price: value?.sale_price,
        discount_price: value?.discount_price,
        discount_percentage: value?.discount_percentage,
        retail_price: value?.description?.product?.sale_price ? value?.description?.product?.sale_price : value?.sale_price ? value?.sale_price : 0,
        expiry_date: value?.expiry_date,
        tax_amount: value?.tax_amount,
        total: value?.total,
      });
    });

    let payment_types = [];
    let payments = [];

    invoice?.payments?.forEach((payment) => {
      if (!payment_types.includes(payment?.name)) {
        payment_types.push(payment?.name);
      }

      payments.push({
        id: payment?._id || `temp-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`,
        name: payment?.name,
        amount: payment?.amount
      });
    });

    totals.subtotal = invoice?.subtotal;
    totals.taxamount = invoice?.taxamount;
    totals.discount_value = invoice?.discount_value;
    totals.discount_type = invoice?.discount_type;
    totals.discount = invoice?.discount;
    totals.delivery = invoice?.delivery;
    totals.delivery_status = invoice?.delivery_status;
    totals.delivery_date = invoice?.delivery_date;
    totals.payment_status = invoice?.payment_status;
    totals.payment_types = payment_types;
    totals.payments = payments;
    totals.total = invoice?.total;

    setValues(currentValues);
    setDetails([...data]);
    setTotals({ ...totals });
    setNote(invoice?.note);
    setLoader(false);
  };

  const fetchData = async () => {
    if (id) {
      setLoader(true);

      const data = {
        id: id,
      };

      const invoice = await get_invoice(data);
      if (invoice?.status) {
        handleData(invoice?.data);
      } else {

        const quotation = await get_quote(data);

        if (quotation?.status) {
          handleData(quotation?.data)
        }
        else {
          toast?.error(invoice?.message);
        }
      }
    } else {
      const filteredValues = getFilteredFormOptions();

      const dateIndex = findFieldIndex("Date");
      const dueDateIndex = findFieldIndex("Due Date");

      if (dateIndex !== -1) {
        filteredValues[0].options[dateIndex].form.value = new Date();
      }

      if (dueDateIndex !== -1) {
        // filteredValues[0].options[dueDateIndex].form.value = new Date();
      }

      setValues(filteredValues);

      totals.delivery_status = 2;
      totals.delivery_date = new Date();
      totals.payment_status = 2;

      setTotals({ ...totals });
      setLoader(false);
    }
  };

  useEffect(() => {
    if (booking_id) {
      handleBookingLoad(booking_id);
    } else if (quotes_id) {
      handleQuotationNumberChange(quotes_id);
    } else {
      fetchData();
    }
  }, [booking_id, quotes_id]);

  return (
    <Header headers={header} setHeaders={setHeader} formdata={formdata}>
      <Loadercomponent loader={loader}>
        <Forms
          form={values}
          setForm={setValues}
          formdata={formdata}
          buttonLoader={buttonLoader}
          selectHandlers={selectHandlers}
        >
          <Bodycomponent>
            <Titlecomponent index={1} title={"Items"} />
            <Formdata>
              <Headercomponent index={0} name={"Details"} required={true} />
              <Invoicetable
                details={details}
                setDetails={setDetails}
                totals={totals}
                setTotals={setTotals}
                ref={focus}
                note={note}
                setNote={setNote}
              />
            </Formdata>
          </Bodycomponent>
        </Forms>
      </Loadercomponent>
    </Header>
  );
};

export default InvoicesForm;
